import { render, staticRenderFns } from "./AsignacionPantalla.vue?vue&type=template&id=1a0e242d&scoped=true&"
import script from "./AsignacionPantalla.vue?vue&type=script&lang=ts&"
export * from "./AsignacionPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionPantalla.vue?vue&type=style&index=0&id=1a0e242d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e242d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1a0e242d', component.options)
    } else {
      api.reload('1a0e242d', component.options)
    }
    module.hot.accept("./AsignacionPantalla.vue?vue&type=template&id=1a0e242d&scoped=true&", function () {
      api.rerender('1a0e242d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/AsignacionMultiFlota/AsignacionPantalla.vue"
export default component.exports